import Vue from 'vue';
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        pageId: {
            id: "1",
            title: "首页",
            href: "/index",
        },

        // 路由堆栈
        routerStack: [],

        showApplay: false,
    },
    // 同步commit => mutations
    mutations : {

        changePageId(state, pageId) {
            state.pageId = pageId
        },
        // 修改路由栈
        changRouterStack(state, routeStack, type) {
            console.log(routeStack + "+" + type)
            if (type == 'push') {
                state.routerStack.push(routeStack);
            } else if (type == 'pop') {
                state.routerStack.pop();
            }
            console.log('routerStack:', state.routerStack);
        },

        changeShowApplay(state, value) {
            state.showApplay = value
        }
    },
    
    // 异步dispatch => actions
    actions : {

    }
})


// WEBPACK FOOTER //
// ./src/store/index.js